export const FOR_YOU_CATEGORY_ID = 'FOR_YOU';

// Every tab shows the same 2x2 grid, so the personalized set is capped here too - the service is
// asked for exactly this many, and a cached response from an older count must not stretch the grid.
export const PROMPT_CARDS_PER_TAB = 4;

// Every data prompt below was run against a live account and kept only if the agent answered it
// outright. The failure mode to avoid is a prompt the agent has to bounce back as a question - it
// leaves the user worse off than an empty composer - so each one names its own time range and asks for
// something the reporting data can actually produce. The Setup prompts are help-center questions
// instead: they name no time range and were not run that way.
export const PROMPT_CATEGORIES = [
    {
        id: 'SETUP',
        prompts: [
            { id: 'PARTNER_POSTBACKS', icon: 'affiliate' },
            { id: 'SKAN_CONVERSION_VALUES', icon: 'device-mobile' },
            { id: 'TRACKING_LINK', icon: 'link' },
            { id: 'MISSING_INSTALLS', icon: 'help' },
        ],
    },
    {
        id: 'PERFORMANCE',
        prompts: [
            { id: 'NETROAS_DROP', icon: 'trending-down' },
            { id: 'COMPARE_CAMPAIGNS', icon: 'chart-bar' },
            { id: 'GEO_EXTREMES', icon: 'world' },
            { id: 'WOW_DELTAS', icon: 'arrows-left-right' },
        ],
    },
    {
        id: 'CREATIVES',
        prompts: [
            { id: 'PAUSE_UNDERPERFORMERS', icon: 'photo' },
            { id: 'SCALE_WINNERS', icon: 'target-arrow' },
            { id: 'CREATIVE_ROAS', icon: 'coin' },
            { id: 'CREATIVE_FATIGUE', icon: 'calendar-stats' },
        ],
    },
    {
        id: 'BUDGET',
        prompts: [
            { id: 'REBALANCE_SPEND', icon: 'currency-dollar' },
            { id: 'SCALE_CANDIDATES', icon: 'trending-up' },
            { id: 'TRIM_CANDIDATES', icon: 'trending-down' },
            { id: 'COST_PER_SOURCE', icon: 'target-arrow' },
        ],
    },
    {
        id: 'RETENTION',
        prompts: [
            { id: 'D1_TO_D7_FALLOFF', icon: 'trending-down' },
            { id: 'RETENTION_BY_GEO', icon: 'world' },
            { id: 'PAYER_CONVERSION', icon: 'coin' },
            { id: 'LTV_PROJECTION', icon: 'chart-line' },
        ],
    },
    {
        id: 'SUMMARY',
        prompts: [
            { id: 'MONTHLY_RECAP', icon: 'report-analytics' },
            { id: 'WEEKLY_RECAP', icon: 'calendar-stats' },
            { id: 'BIGGEST_MOVERS', icon: 'arrows-left-right' },
            { id: 'EXEC_SUMMARY', icon: 'file-text' },
        ],
    },
    {
        id: 'VISUALIZATIONS',
        prompts: [
            { id: 'BUILD_DASHBOARD', icon: 'layout-dashboard' },
            { id: 'CHART_A_TREND', icon: 'chart-line' },
            { id: 'COMPARE_SOURCES', icon: 'chart-bar' },
            { id: 'MAP_BY_GEO', icon: 'world' },
        ],
    },
];
